// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const EditIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="EditIcon" ref={forwardedRef} {...props}>
      <path d="M15.67 2.365a1.246 1.246 0 0 0-1.763 0l-9.663 9.669-2.104 4.15c-.544 1.073.598 2.22 1.673 1.677l4.158-2.097 9.664-9.67a1.247 1.247 0 0 0 0-1.763zm-1.995 2.349L14.79 3.6l1.61 1.613-1.114 1.114zm-1.057 1.058 1.612 1.613-7.147 7.15-3.265 1.648 1.652-3.26z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const EditIcon = /* @__PURE__ */ Object.assign(EditIconComponent, {
  displayName: 'EditIcon',
});
